import template from './adpInput.html';
import controller from './adpInput.controller';
import './adpInput.less';

let adpInputComponent = {
  restrict: 'E',
  bindings: {
    label: "@",
    placeholder: "@",
    inputId: "@",
    type: "@",
    isRequired: "<",
    isDisabled: "<",
    hasErrorTooltip: "<",
    additionalLabelClarification: "@",
    isSelected: "=?"
  },
  template,
  transclude: {
    message: "?tooltipMsg"
  },
  controller
};

export default adpInputComponent;



// WEBPACK FOOTER //
// ./src/app/components/adpInput/adpInput.component.js